export const Windows = ({ width = '20', height = '20' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25_9544)">
        <path
          d="M14 5H2C0.897 5 0 5.897 0 7V17C0 18.103 0.897 19 2 19H14C15.103 19 16 18.103 16 17V7C16 5.897 15.103 5 14 5ZM2 17V9H14V7L14.002 17H2Z"
          fill="white"
          fillOpacity="0.4"
        />
        <path
          d="M20 3C20 1.897 19.103 1 18 1H5C3.897 1 3 1.897 3 3H16.001C17.102 3 17.997 3.895 18 4.994L18.002 13H18V15C19.103 15 20 14.103 20 13V6.007L20.001 6V4L20 3.99V3Z"
          fill="white"
          fillOpacity="0.4"
        />
      </g>
      <defs>
        <clipPath id="clip0_25_9544">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
